// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 943 ? "react-syntax-highlighter/refractor-core-import" : chunkId) + "." + {"326":"027232b2","410":"6b0591dd","518":"647ca7de","698":"3dcb8bc4","738":"da5515f1","823":"009f395b","895":"822e6d4e","943":"5cd68c5f"}[chunkId] + ".chunk.js";
};